import {VideoRetryScreenIconDefaultBox} from "./video-retry-screen-icon-default.box";

export const VideoRetryScreenIconBox = VideoRetryScreenIconDefaultBox;
